import { xMaxValue } from "../x/index.js";
import { matrixCreateEmpty } from "./matrixCreateEmpty.js";
/**
 * Numerically encodes the strings in the matrix with an encoding dictionary.
 * @param matrixInitial - original matrix before encoding.
 * @param dictionary - dictionary against which to do the encoding.
 * @returns encoded matrix.
 */
export function matrixApplyNumericalEncoding(matrixInitial, dictionary) {
    const matrix = matrixCreateEmpty({
        nbRows: matrixInitial.length,
        nbColumns: matrixInitial[0].length,
        ArrayConstructor: Array,
    });
    const arrayOfValues = [];
    for (const key in dictionary) {
        arrayOfValues.push(dictionary[key]);
    }
    let k = xMaxValue(arrayOfValues);
    for (const row of matrix) {
        for (let j = 0; j < matrix[0].length; j++) {
            if (typeof row[j] === 'string') {
                if (row[j] in dictionary) {
                    row[j] = dictionary[row[j]];
                }
                else {
                    k++;
                    dictionary[row[j]] = k;
                    row[j] = k;
                }
            }
        }
    }
    return matrix;
}
//# sourceMappingURL=matrixApplyNumericalEncoding.js.map